import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, deleteToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBvPueyCZt8b1dJsNPQvSfQlq6rmpKDtrg',
  authDomain: 'leadboat-7cc51.firebaseapp.com',
  projectId: 'leadboat-7cc51',
  storageBucket: 'leadboat-7cc51.firebasestorage.app',
  messagingSenderId: '469087521530',
  appId: '1:469087521530:web:27f5d6ed7bef79d41c1743',
  measurementId: 'G-FZMPMTT0S7',
};

// Web Push certificate key pair from the leadboat-7cc51 project
// (Console → Project settings → Cloud Messaging → Web Push certificates).
const VAPID_KEY = 'BHnWj9-6F_7L6wG3CUgsLFISiarp5czFAIL8eCrjpW0ypvChbaJypWlg1lfw7-V977Ug93Y0gylwlYwrwwG69ao';

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {}

/**
 * Request notification permission and get FCM token
 */
export const requestNotificationPermission = async () => {
  try {
    if (!messaging) return null;
    if (!VAPID_KEY) {
      console.warn('[FCM] VAPID key missing — web push disabled');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    return token;
  } catch (err) {
    return null;
  }
};

/**
 * Delete this browser's FCM token, so the next login registers a fresh one and
 * a shared browser stops receiving the previous user's notifications.
 */
export const deleteFcmToken = async () => {
  try {
    if (!messaging) return;
    await deleteToken(messaging);
  } catch (err) {
    console.warn('[FCM] delete token failed:', err?.message);
  }
};

/**
 * Listen for foreground messages
 */
export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
};

export { messaging };
